<script>
import signIn from '@/components/sign_in/sign_in.vue';

export default {
  computed: {
    auth() {
      return this.$store.getters.AUTH;
    },
    token() {
      return this.$store.getters.TOKEN;
    },
    email() {
      return this.$store.getters.EMAIL;
    },
    shop_id() {
      return this.$store.getters.SHOP_ID;
    },
    page() {
      return this.$store.state.page;
    },
    modal_inform() {
      return this.$store.state.users.modal_inform;
    },
  },
  components: {
    sign_in_component: signIn,
  },
};
</script>
<template lang="pug">
  .wrapper.app
    router-view
    notifications
    sign_in_component(v-if="!auth && !!token", class="sign_in_transparent")
</template>
